import { Pipe, PipeTransform } from '@angular/core';

import { DatePipe } from '@angular/common';

@Pipe({
  name: 'formatDateAndTime',
  standalone: false,
})
export class FormatDateAndTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform({ date, time }): string {
    const formattedDate = date ? `${this.datePipe.transform(date, 'dd MMMM yyyy')}` : '';
    const formattedTime = time ? `at ${time}` : '';

    return `${formattedDate} ${formattedTime}`;
  }
}
